import { createSlice } from "@reduxjs/toolkit";

export const reduxBoard = createSlice({
    name: 'name_reduxBoard',//변경해도 의미 없네 (내부적으로 식별 용도인 듯)
    initialState: {
        value1: 1,
        list: [],
        selectedList: {},
        selectedListFile: {},
        boardTitle:{},
        boardKind: '',
        initialPage: 0,
        isFileListSelect: false,
        isLoggedIn: false,
        userInfo: {},
        defaultUploadFoler: null,
        isSubmenuVisible: false,
        selectedSection: 1,
        isAdmin: false,
        isSelectedCommunity: false,
        isRefreshBoard: false,
    },
    
    reducers: {

        setList: (state, action) => {
            state.list = action.payload;
        },

        setSelectedList: (state, action) => {
            state.selectedList = action.payload;
        },

        setSelectedListFile: (state, action) => {
            state.selectedListFile = action.payload;
        },
      
        setBoardTitle: (state, action) => {
            state.boardTitle = action.payload;
        },
        setBoardKind: (state, action) => {
            state.boardKind = action.payload;
        },
        setInitialPage: (state, action) => {
            state.initialPage = action.payload;
        },
        setIsFileListSelect: (state, action) => {
            state.isFileListSelect = action.payload;
        },
        setIsLoggedIn: (state, action) => {
            state.isLoggedIn = action.payload;
        },
        setUserInfo: (state, action) => {
            state.userInfo = action.payload;
        },
        setDefaultUploadFoler: (state, action) => {
            state.defaultUploadFoler = action.payload;
        },
        setIsSubmenuVisible: (state, action) => {
            state.isSubmenuVisible = action.payload;
        },
        setSelectedSection: (state, action) => {
            state.selectedSection = action.payload;
        },
        setIsAdmin: (state, action) => {
            state.isAdmin = action.payload;
        },
        setIsSelectedCommunity: (state, action) => {
            state.isSelectedCommunity = action.payload;
        },
        setIsRefreshBoard: (state, action) => {
            state.isRefreshBoard = action.payload;
        }
     
    }


});



export const { 
    increment, 
    setList, setList2,
    setBoardTitle, 
    setBoardKind,
    setSelectedList,
    setSelectedListFile,
    setInitialPage,
    setIsFileListSelect,
    setIsLoggedIn,
    setUserInfo,
    setDefaultUploadFoler,
    setIsSubmenuVisible,
    setSelectedSection,
    setIsAdmin,
    setIsSelectedCommunity,
    setIsRefreshBoard,
   
} = reduxBoard.actions;

export default reduxBoard.reducer;

